import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Button, Grid, Input, Item } from "semantic-ui-react";
import LasServiceApi from "../../api/lasService";
import Logo from "../../components/Logo/Logo";

import { useAppSelector as useSelector } from "../../hooks/redux";

import style from "./style.module.css";

export default function LasServiceFormPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const state = useSelector((s) => s);
  const history = useHistory();

  const [price, setPrice] = useState("");

  const validForm = () => {
    if (price === "") {
      return false;
    }
    return true;
  };

  const saveLasService = async () => {
    setLoading(true);
    setError("");
    try {
      await LasServiceApi.updateLasService(
        price,

        state.lasService.lasService!.id
      );
      history.replace("/lasServiceContract");
    } catch (err) {
      console.log(err);
    }
    setError("problema al guardar");
    setLoading(false);
  };

  const loadLasService = async () => {
    try {
      const updateLasService = await LasServiceApi.getUpdatedLasService(
        state.lasService.lasService!.id
      );
      if (updateLasService) {
        setPrice(updateLasService.price);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadLasService();
    // eslint-disable-next-line
  }, []);

  const validateCurrency = (s: string) => {
    if (s.length === 0) {
      return true;
    }

    if (s.includes(".") && s.split(".").length - 1 > 1) {
      return false;
    }

    if (s.split(".")[1] && s.split(".")[1].length > 2) {
      return false;
    }

    if (s.replaceAll(".", "").match(/\D/g) === null) {
      return true;
    }

    return false;
  };

  return (
    <div className={style.container}>
      <Logo />
      {/* <Header as="h1">Smart Contract</Header> */}
      <Grid columns={3} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Serviço</Item.Header>
                <Item.Meta>
                  <label>Codigo:</label>
                  <span>{state.lasService.lasService?.service}</span>
                  <br />
                  <label>Preço atual:</label>
                  <span>{state.lasService.lasService?.price}</span>
                  <br />
                  <label>Descripcion:</label>
                  <span>{state.lasService.lasService?.description}</span>
                  <br />
                  <label>Subdescripcion:</label>
                  <span>{state.lasService.lasService?.longDescription}</span>
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Precio Actual *:</label>
            <br />
            <Input
              value={price}
              onChange={(e) => {
                if (validateCurrency(e.target.value.replace(",", "."))) {
                  setPrice(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(price))) {
                  setPrice("");
                } else {
                  setPrice(parseFloat(price).toFixed(2));
                }
              }}
              placeholder="Precio"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <Grid.Row>
            <Button
              onClick={() => {
                history.goBack();
              }}
              color="red"
            >
              Cancelar
            </Button>
            <Button
              loading={loading}
              disabled={!validForm()}
              onClick={saveLasService}
              primary
            >
              Guardar
            </Button>
            <text className={style.error}>{error}</text>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    </div>
  );
}
